.transport {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.tempo {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  font-variant-numeric: tabular-nums;
}

.sing {
  margin-left: auto;
}

/* Spec §9: on a phone, 44px targets and a large Sing an idea; the editor pins the bar to the bottom */
@media (max-width: 599.95px) {
  .transport > * {
    min-height: 44px;
  }

  .sing {
    flex: 1 0 100%;
  }
}
